import React from 'react';

export default function UserStoryBillingBadge({ story }) {
  return (
    <span
      title="Statut déterminé par le lien avec un bon de commande"
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${story.isBilled ? 'bg-emerald-50 text-emerald-700' : 'bg-gray-100 text-gray-600'}`}
    >
      {story.isBilled ? 'Facturée' : 'Non facturée'}
      {story.isBilled && story.saleOrderName ? ` · ${story.saleOrderName}` : ''}
    </span>
  );
}
